export const isProspect = (type) => {
    return type ? type.includes("prospect") : false;
};

export const isCommunityPortal = (type) => {
    return type ? type.includes("community-portal") : false;
};
